import React from 'react'

export interface IconSendPNProps {
    className?: string
    fillColor?: string
}

export const IconSendPN: React.FC<IconSendPNProps> = ({
    className,
    fillColor = '#666869',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
        >
            <path
                d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13"
                stroke={fillColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
